// extracted by mini-css-extract-plugin
export default {"indicator":"hYqyz","indicator--badge":"Vl49_","indicator--icon":"xDjQb","indicator--scaling":"ywtLs","indicator--optimal":"jND8c"};